import React from "react";


export const MultiCurrencyContext = React.createContext(null);
